/**
 * @功能名称:
 * @文件名称: getQueryJsonAll.js
 * @Date: 2019/12/10 上午10:25.
 * @Author: yanghao
 * @Copyright（C）: 2014-2019 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
import getQueryJson from './getQueryJson'

function getQueryJsonAll(href) {
  let rusultBefore = getQueryJson();
  let hash = location.hash;
  let resultAfter = getQueryJson(hash)
  return Object.assign(resultAfter, rusultBefore);
}
export default getQueryJsonAll